<div
  class="checkbox"
  id="checkbox"
  [ngClass]="{ disabled: disabled, destructive: destructive }"
  [ngStyle]="{ 'background-color': getCheckboxBackGroundColor(), border: checkFocusBorder() ? '1px solid ' + getCheckboxBorder() : '' }"
  (focus)="setFocus(true)"
  (blur)="setFocus(false)"
  (click)="setCheck()">
  <img *ngIf="checked" [src]="checkedImg" class="check-img" [ngClass]="{ disabled: disabled }" />
</div>
